module.exports = __webpack_public_path__ + "assets/work-with-a-sales-recruiting-agency-4.3da4857c.png";